<template>
  <div class="p-personMemo mt30" :id="`memo-${memo.id}`">
    <div class="p-personMemo-speechBubbleHeader bgc-red">
      <div class="p-personMemo-speechBubbleHeader-inner bgc-white plr15 d-f ai-c gap5">
        <div class="ptb10">
          <p class="fw-b fz115">{{ memo.company_name }}</p>
          <p class="fw-b fz85">{{ memo.job_name }}</p>
        </div>
        <p class="p-personMemo-speechBubbleHeader-createdAt fz85 fw-b c-black80">生成日：{{ memo.created_at }}</p>
      </div>
      <span class="p-personMemo-speechBubbleHeader-triangle"></span>
    </div>
    <div class="mt20">
      <textarea class="u-input-textarea u-input-autoFlexTextarea js-autoFlexTextarea" rows="6" name="text" v-model="memo.text"></textarea>
      <div class="d-f jc-fe mt20">
        <button type="submit" class="u-reset-button bgc-key bdrs-max c-white d-if jc-c ai-c fw-b" style="width: 90px; height: 30px;" @click="onSaveClick">
          <span v-show="!nowSending"><span class="d-if jc-c ai-c gap5"><i class="u-icon-save"></i>保存</span></span>
          <span class="rotate" v-show="nowSending"><i class="u-icon-refresh"></i></span>
        </button>
      </div>
    </div>
    <button type="button" class="p-personMemo-removeButton bgc-black100 js-modalToggle" data-modal="deleteMemo-confirmationModal" @click="onDeleteClick"><i class="u-icon-cross c-white"></i></button>
  </div>
</template>

<script>
  export default {
    props: {
      propMemo: { type: Object, required: true },
    },
    data() {
      return {
        nowSending: false,
        memo: this.propMemo,
      }
    },
    created() {
      this.memo = this.propMemo;
    },
    methods: {
      async onSaveClick() {
        this.nowSending = true;
        this.$emit('update', {
          memoId: this.memo.id,
          text: this.memo.text,
          onFinally: () => {
            this.nowSending = false;
          },
        })
      },
      async onDeleteClick() {
        this.$emit('delete', {
          memoId: this.memo.id,
          onFinally: () => {},
        });
      },
    }
  }
</script>

<style scoped>
.rotate {
  animation: spin 3s linear infinite;
}
@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
</style>
